import { render, staticRenderFns } from "./DetailedAccountStatement.vue?vue&type=template&id=f16766f2&scoped=true&"
import script from "./DetailedAccountStatement.vue?vue&type=script&lang=js&"
export * from "./DetailedAccountStatement.vue?vue&type=script&lang=js&"
import style0 from "./DetailedAccountStatement.vue?vue&type=style&index=0&id=f16766f2&prod&scoped=true&lang=css&"
import style1 from "./DetailedAccountStatement.vue?vue&type=style&index=1&id=f16766f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16766f2",
  null
  
)

export default component.exports